<template>
    <div>
      <v-container>
        <!-- Header -->
        <v-row align="center">
          <v-col cols="3">
            <base-title no-margin-top>Preferences</base-title>
          </v-col>
        </v-row>
        <!-- Header -->

        
        <v-row>
            <!-- Side bar -->
            <v-col cols="3">
                <SideNavigation :active="activeTab" />
            </v-col>
            <!-- Side bar -->

            <!-- Favorite Medicines -->
            <v-col cols="9" v-if="activeTab == 'fav'">
              <Favorites />
            </v-col>
            <!-- Favorite Medicines -->

            <!-- Diagnosis Medicines -->
            <v-col cols="9" v-if="activeTab == 'icd'">
              <Diagnosis />
            </v-col>
            <!-- Diagnosis Medicines -->

            <v-col cols="9" v-if="activeTab == 'text'">
              <TextReplacement />
            </v-col>

        </v-row>
        

      </v-container>
    </div>
  </template>

<script>

import SideNavigation from './SideNavigation.vue';
import Favorites from './Tabs/Favorites.vue';
import Diagnosis from './Tabs/Diagnosis.vue';
import TextReplacement from './Tabs/TextReplacement.vue';

export default {
    name: 'Preference',
    components: { SideNavigation, Favorites, Diagnosis, TextReplacement },
    data() {
        return {
            activeTab: 'fav'
        }
    },
    methods: {
        changeTab (tab) {
            this.activeTab = tab;
        }
    }
}
</script>